export default __webpack_public_path__ + "static/media/cs_Just_Figures.88c6a467.png";